export default "__VITE_ASSET__BVDIGn5o__"